import { lazy, JSX } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import PrivateRoute from './pages/users/partials/auth/private_route';

const EmptyLayout = lazy(() => import('./layouts/empty'));
const NewLayout = lazy(() => import('./layouts/new'));
const Layout = lazy(() => import('./layouts/layout'));
const POSIndex = lazy(() => import('./pages/pos'));
const CashierIndex = lazy(() => import('./pages/cashier'));
const OrdersIndex = lazy(() => import('./pages/orders'));
const InventoryIndex = lazy(() => import('./pages/inventory'));
const InventoryDetail = lazy(() => import('./pages/inventory/detail'));
const InventoryNew = lazy(() => import('./pages/inventory/new'));
const InventoryConfirm = lazy(() => import('./pages/inventory/confirm'));
const UsersIndex = lazy(() => import('./pages/users'));
const ErrorsIndex = lazy(() => import('./pages/errors'));

function App() {
  const evRoute = (path: string, element:JSX.Element, as?: string, isStore= true as boolean, layoutElement?:JSX.Element) => {
    const layout = layoutElement || <Layout />;
    return (
      <Route path={path} element={<PrivateRoute as={as} isStore={isStore} />}>
        <Route element={layout}>
          <Route index element={element} />
        </Route>
      </Route>
    );
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path={`${process.env.PUBLIC_URL}/users`} element={<EmptyLayout />}>
          <Route index element={<UsersIndex />} />
          <Route path='xyz' element={<UsersIndex />} />
          <Route path='forgot' element={<UsersIndex />} />
          <Route path='login' element={<UsersIndex />} />
          <Route path='verify' element={<UsersIndex />} />
        </Route>

        <Route path={`${process.env.PUBLIC_URL}/restricted`} element={<ErrorsIndex section='restricted' />} />

        { evRoute(process.env.PUBLIC_URL+'/inventory/adjustment/confirm/:id', <InventoryConfirm sections='adjustment'/>, 'pos', true, <NewLayout />) }
        { evRoute(process.env.PUBLIC_URL+'/inventory/inbound/confirm/:id', <InventoryConfirm sections='inbound'/>, 'pos', true, <NewLayout />) }
        { evRoute(process.env.PUBLIC_URL+'/inventory/outbound/confirm/:id', <InventoryConfirm sections='outbound'/>, 'pos', true, <NewLayout />) }
        
        { evRoute(process.env.PUBLIC_URL+'/inventory/adjustment/:id', <InventoryDetail sections='adjustment'/>, 'pos') }
        { evRoute(process.env.PUBLIC_URL+'/inventory/inbound/:id', <InventoryDetail sections='inbound'/>, 'pos') }
        { evRoute(process.env.PUBLIC_URL+'/inventory/outbound/:id', <InventoryDetail sections='outbound'/>, 'pos') }

        { evRoute(process.env.PUBLIC_URL+'/inventory/adjustment/new', <InventoryNew sections='adjustment'/>, 'pos', true, <NewLayout />) }
        { evRoute(process.env.PUBLIC_URL+'/inventory/inbound/new', <InventoryNew sections='inbound'/>, 'pos', true, <NewLayout />) }
        { evRoute(process.env.PUBLIC_URL+'/inventory/outbound/new', <InventoryNew sections='outbound'/>, 'pos', true, <NewLayout />) }

        { evRoute(process.env.PUBLIC_URL+'/inventory/quantity', <InventoryIndex sections='quantity'/>, 'pos') }
        { evRoute(process.env.PUBLIC_URL+'/inventory/adjustment', <InventoryIndex sections='adjustment'/>, 'pos' ) }
        { evRoute(process.env.PUBLIC_URL+'/inventory/inbound', <InventoryIndex sections='inbound'/>, 'pos') }
        { evRoute(process.env.PUBLIC_URL+'/inventory/outbound', <InventoryIndex sections='outbound'/>, 'pos') }
        { evRoute(process.env.PUBLIC_URL+'/inventory/history', <InventoryIndex sections='history'/>, 'pos') }

        { evRoute(process.env.PUBLIC_URL+'/cashier', <CashierIndex />, 'pos') }

        { evRoute(process.env.PUBLIC_URL+'/orders', <OrdersIndex />, 'pos') }
        
        { evRoute(process.env.PUBLIC_URL+'/', <POSIndex />, 'pos', false) }
        
        <Route path='*' element={<ErrorsIndex section='not-found' />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
